export { default } from "./SpeedDial.js";
export { default as speedDialClasses } from "./speedDialClasses.js";
export * from "./speedDialClasses.js";